// extracted by mini-css-extract-plugin
export default {"aboutPopup":"about_aboutPopup__yPp-z","img":"about_img__CosoP","content":"about_content__c1mkj"};